var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    rx: 12,
    fill: "url(#bot_svg__paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bot_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4 55.8c3.4 0 6.6-2.9 6.4-6.4-.1-3.5-2.8-6.4-6.4-6.4-3.3 0-6.5 2.9-6.4 6.4.2 3.5 2.8 6.4 6.4 6.4zM90.6 55.8c3.4 0 6.6-2.9 6.4-6.4-.1-3.5-2.8-6.4-6.4-6.4-3.4 0-6.6 2.9-6.4 6.4.2 3.5 2.8 6.4 6.4 6.4zM59 75.4c-8.7 0-17-3.3-23.4-9.2-2.6-2.4-2.8-6.6-.4-9.2 2.4-2.6 6.6-2.8 9.2-.4 4 3.7 9.2 5.7 14.6 5.7s10.6-2 14.6-5.7c2.6-2.4 6.7-2.3 9.2.4 2.4 2.6 2.3 6.7-.4 9.2-6.3 5.9-14.7 9.2-23.4 9.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bot_svg__paint0_linear",
    x1: 59,
    y1: 0,
    x2: 59,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC792C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4E60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bot_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 43h78.1v32.5H20z"
  })))));
}

export default SvgBot;